import "core-js/modules/es.array.push.js";
import OrderSummary from './../shared/order-summary.vue';
import CartItem from '../shared/cart-item.vue';
import AddressBox from '../shared/address-box.vue';
import CartAlertBox from '../shared/cart-alert-box.vue';
import { Tooltip } from '../../blocks/output-elements/tooltip';
export default {
  name: 'PopulatedCart',
  emits: ["show-remove-item-modal"],
  props: ['cartData', 'apiCallFailure'],
  components: {
    OrderSummary,
    AddressBox,
    CartAlertBox,
    CartItem,
    Tooltip
  },
  data() {
    return {
      cartEntries: this.cartData?.cartData.entries,
      isMultiPO: this.cartData?.cartData.isMultiPO,
      cartItemLimit: 25,
      isEmptyCartError: false,
      originalPONumber: this.cartData?.cartData?.purchaseOrderNumber,
      isSaveFailure: false,
      hasPopulatedPOs: false
    };
  },
  created() {
    this.populateItemPOs();
  },
  watch: {
    cartData: {
      immediate: true,
      handler(newVal) {
        if (newVal && newVal.cartData && newVal.cartData.entries) {
          this.cartEntries = newVal.cartData.entries;
          this.cartEntries.forEach(entry => {
            entry.poNumber = entry.lineItemPO;
          });
          this.isMultiPO = newVal.cartData.isMultiPO;
        }
      }
    }
  },
  methods: {
    getI18nMessage: function (key) {
      return window.Granite.I18n.get(key);
    },
    emitRemoveItemModal(item) {
      this.$emit('show-remove-item-modal', {
        item,
        showModal: true
      });
    },
    emptyCartFailure() {
      this.isEmptyCartError = true;
    },
    saveFailure(state) {
      this.isSaveFailure = state;
    },
    updateEntries(entries) {
      this.cartEntries = entries;
    },
    isCheckoutDisabled() {
      return this.cartData?.cartData?.unConfiguredEntries?.length > 0 || this.cartData?.cartData?.needRemoveEntries?.length > 0 || this.cartData?.cartData?.needEditEntries?.length > 0 && this.pricingFlagExistsInCart || this.cartEntries?.length > this.cartItemLimit || this.poError;
    },
    isUnconfiguredEntry(cartEntry) {
      let unconfiguredEntries = this.cartData?.cartData.unConfiguredEntries;
      return unconfiguredEntries && unconfiguredEntries.find(entry => entry.sapLineItemNumber == cartEntry.sapLineItemNumber) ? true : false;
    },
    isNeedRemoveEntry(cartEntry) {
      let needRemoveEntries = this.cartData?.cartData.needRemoveEntries;
      return needRemoveEntries && needRemoveEntries.find(entry => entry.sapLineItemNumber == cartEntry.sapLineItemNumber) ? true : false;
    },
    isNeedEditEntry(cartEntry) {
      let needEditEntries = this.cartData?.cartData.needEditEntries;
      return needEditEntries && needEditEntries.find(entry => entry.sapLineItemNumber == cartEntry.sapLineItemNumber) && cartEntry.pricingAvailabilityInvalidForShipToFlag ? true : false;
    },
    getPONum() {
      let entriesWithPONum = this.cartEntries?.filter(entry => entry.lineItemPO);
      return entriesWithPONum?.length > 0 && entriesWithPONum.every(entry => entry.lineItemPO === entriesWithPONum[0].lineItemPO) ? entriesWithPONum[0].lineItemPO : '';
    },
    populateItemPOs() {
      if (this.hasHeaderPOValue) {
        let entries = [];
        this.cartEntries.forEach(entry => {
          if (entry.poNumber === "" || entry.poNumber === undefined) {
            entry.poNumber = this.cartData?.cartData.purchaseOrderNumber;
            entries.push(entry.sapLineItemNumber);
          }
        });
        if (entries.length > 0) {
          this.updatePONumber(false, entries);
        } else {
          this.hasPopulatedPOs = true;
        }
      } else {
        this.hasPopulatedPOs = true;
      }
    },
    resetItemValidity() {
      this.cartEntries.forEach(entry => {
        if (entry.poNumber === "" || entry.poNumber === undefined) {
          entry.isPoInvalid = false;
        }
      });
    },
    updateHeaderPO() {
      if (this.hasHeaderPOValue) {
        this.cartData.cartData.purchaseOrderNumber = this.cartData.cartData.purchaseOrderNumber.trim();
      }
      this.resetItemValidity();
      if (this.hasHeaderPOValue) {
        let entries = this.cartEntries.map(entry => entry.sapLineItemNumber);
        this.updatePONumber(true, entries);
      } else if (this.cartData?.cartData?.purchaseOrderNumber === "") {
        this.updatePONumber(true, []);
      }
    },
    updatePONumber(hasPurchaseOrderNumberUpdated, entries) {
      this.$store.commit('cart/updateLineItemNumbersToSave', {
        "hasPurchaseOrderNumberUpdated": hasPurchaseOrderNumberUpdated,
        "purchaseOrderNumberValue": this.cartData?.cartData.purchaseOrderNumber,
        "sapLineItemNumbers": entries
      });
      this.saveFailure(false);
      let self = this;
      this.$store.dispatch('cart/updatePONumber').then(data => {
        self.originalPONumber = data.cartData?.purchaseOrderNumber; // update to new value
        self.updateCartData(data);
      }).catch(error => {
        console.log("Error", error);
        this.saveFailure(true);
      }).finally(() => {
        this.hasPopulatedPOs = true;
      });
    },
    updateCartData(data) {
      this.$emit("cartDataUpdated", data);
    },
    validateItems() {
      this.cartEntries.forEach(entry => {
        entry.isPoInvalid = false;
        this.validateItem(entry);
      });
      localStorage.setItem('headerPOUsed', this.hasHeaderPOValue);
    },
    validateItem(item) {
      item.isPoInvalid = item.poNumber === "" || item.poNumber === undefined || item.poNumber.length > 35;
    }
  },
  computed: {
    hasForwardingAgent() {
      return this.cartEntries && this.cartEntries.some(entry => entry.forwardingAgent);
    },
    poError() {
      return this.cartEntries.filter(entry => {
        return entry.isPoInvalid;
      }).length > 0;
    },
    isHeaderPODisabled() {
      let isAnyEntryPopulated = this.cartEntries.filter(entry => {
        return entry.poNumber != "" && entry.poNumber != undefined;
      }).length > 0;
      let isCurrentlySaving = this.lineItemNumbersToSave && this.lineItemNumbersToSave.length > 0;
      return isAnyEntryPopulated || isCurrentlySaving;
    },
    hasHeaderPOValue() {
      return this.cartData?.cartData?.purchaseOrderNumber != undefined && this.cartData?.cartData?.purchaseOrderNumber != "";
    },
    lineItemNumbersToSave() {
      return this.$store.getters['cart/getLineItemNumbersToSave'];
    },
    pricingFlagExistsInCart() {
      return this.cartEntries.some(entry => entry.pricingAvailabilityInvalidForShipToFlag);
    }
  }
};